module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00056))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00054))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00016))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.localFormData.scenarios), function(scenario, index) {
    return _c('div', {
      key: ("scenario-" + (scenario.ScenarioId)),
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [(_vm.localFormData && _vm.briefingAttachments) ? _c('select', {
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      domProps: {
        "value": _vm.getValue(scenario.ScenarioId, 'Briefing')
      },
      on: {
        "change": function($event) {
          return _vm.setValue(scenario.ScenarioId, 'Briefing', $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00057))]), _vm._v(" "), _vm._l((_vm.briefingAttachments), function(file) {
      return _c('option', {
        key: file.DownloadId,
        domProps: {
          "value": file.DownloadId
        }
      }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))])
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [(_vm.localFormData && _vm.surveyAttachments) ? _c('select', {
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      domProps: {
        "value": _vm.getValue(scenario.ScenarioId, 'Survey')
      },
      on: {
        "change": function($event) {
          return _vm.setValue(scenario.ScenarioId, 'Survey', $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00058))]), _vm._v(" "), _vm._l((_vm.surveyAttachments), function(file) {
      return _c('option', {
        key: file.DownloadId,
        domProps: {
          "value": file.DownloadId
        }
      }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))])
    })], 2) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "uploaded-files-section"
  }, [_c('div', [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.lang.W00059))])]), _vm._v(" "), _c('div', {
    staticClass: "files-list"
  }, _vm._l((_vm.briefingAttachments), function(file) {
    return _c('div', {
      key: file.DownloadId,
      staticClass: "file-item",
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(file.DownloadId)
        }
      }
    }, [_c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))]), _vm._v(" "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("file_download")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-container"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputBriefingAttachmentFile",
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": function($event) {
        return _vm.onInputChange($event, 'Briefing')
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.lang.W00060))])]), _vm._v(" "), _c('div', {
    staticClass: "files-list"
  }, _vm._l((_vm.surveyAttachments), function(file) {
    return _c('div', {
      key: file.DownloadId,
      staticClass: "file-item",
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(file.DownloadId)
        }
      }
    }, [_c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.FileName) + "." + _vm._s(file.FileType))]), _vm._v(" "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("file_download")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-container"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": function($event) {
        return _vm.onInputChange($event, 'Survey')
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "wizard-btn-dark",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "for": "inputBriefingAttachmentFile"
    }
  }, [_vm._v("\n            Upload briefing\n            "), _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("file_upload")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "wizard-btn-dark",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v("\n            Upload survey\n            "), _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("file_upload")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff177a44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step7.vue
// module id = 1738
// module chunks = 1